import { takeLatest, put, select, call } from 'redux-saga/effects';
import * as actions from './actions';
import * as types from './types';
import * as baseTypes from '../base/types';
import { intervalSelector } from '../base/selectors';
import moment from 'moment';

function* setupState() {
  const baseInterval = yield select(intervalSelector);
  const { to: baseTo } = baseInterval;
  const from = moment(baseTo).subtract('hour', 1).format();
  yield put(actions.setSelectedBar(from, -1));
}

function* watchSetupRequest() {
  yield takeLatest([
    types.SETUP,
    baseTypes.SET_INTERVAL,
  ], setupState);
}

export default [
  watchSetupRequest,
];
